export function resolveAllowedOrigin(src: string): string[] {
  try {
    return [new URL(src).origin];
  } catch {
    return [];
  }
}
